// extracted by mini-css-extract-plugin
module.exports = {"safeArea":"index-module_safeArea_2_dNU","navBarHeight":"index-module_navBarHeight_NG9Mj"};